
import { Component, Prop, Vue } from 'vue-property-decorator'


import Mp3Player from '@/components/mp3Player.vue'
import Mp4Player from '@/components/mp4Player.vue'

import { AnswerType } from '@/utils/const'
import Bus from '@/utils/bus'
import { htmlClick, htmlDecode } from '@/utils/helpers'

@Component({
  components: {
    Mp3Player,
    Mp4Player
  }
})
export default class AnswerMsg extends Vue {
  @Prop()
  readonly item!: any

  @Prop({ type: Boolean, default: true })
  showFileName!: boolean

  @Prop()
  commonInfo!: any

  get primaryColor() {
    return document.documentElement.style.getPropertyValue('--primary-color')
  }

  readonly AnswerType = AnswerType
  htmlDecode = htmlDecode
  hasViewMore = false
  // 默认是false, 青岛12333要求默认展示全部,因此设置为true
  showMore = window.config.showAnswerMode === 'UnFold'

  get hasText () {
    return [AnswerType.PureText, AnswerType.RichText, AnswerType.PictAndText].includes(this.item.contentType)
  }

  mounted () {
    const contentText: any = this.$refs.contentText
    if (contentText) {
      const imgs = contentText.querySelectorAll('img')
      this.imgAllLoad(imgs).then((res) => {
        if (imgs.length) {
          this.$emit('imgAllLoad')
        }

        const scrollHeight = contentText.scrollHeight
        const offsetHeight = contentText.offsetHeight
        // TODO 允许有3px的误差
        if (scrollHeight > offsetHeight + 3) {
          this.hasViewMore = true
        } else {
          this.hasViewMore = false
        }
      })
    }
  }

  imgAllLoad (imgList: NodeList) {
    const array: any = []
    imgList.forEach((img: any) => {
      array.push(this.imgPromise(img))
    })
    return Promise.all(array)
  }

  imgPromise (img: HTMLImageElement) {
    const promise = new Promise((resolve, reject) => {
      img.onload = () => {
        if (img.complete) {
          resolve('')
        }
      }
      img.onerror = () => {
        resolve('')
      }
    })
    return promise
  }

  viewMore () {
    this.showMore = true
  }

  /**
   *
   */
  onClick (e: Event) {
    htmlClick(e, this)
  }

  sendQuestion(question: string) {
    Bus.$emit('requestAnswer', question)
  }

  /**
   * 获取文件名称
   */
  getFileName (filePath: string) {
    const index = filePath.lastIndexOf('/')
    return filePath.slice(index + 1)
  }

  getIconClass (obj: any) {
    const fileType = obj.fileType
    switch (fileType) {
      case 'pdf':
        return 'icon-PDF'
      case 'ppt':
      case 'pptx':
        return 'icon-PPT'
      case 'xls':
      case 'xlsx':
        return 'icon-xlsx'
      case 'doc':
      case 'docx':
        return 'icon-wendang-docx_doc'
      case 'txt':
        return 'icon-txt1'
      case 'rar':
      case 'zip':
      case 'tar':
        return 'icon-rar1'
      case 'accdb':
        return 'icon-accdb'
      case 'bmp':
        return 'icon-tupiankongjian'
      case 'pub':
        return 'icon-pub'
      default:
        return 'icon-File1'
    }
  }

  previewPdf (url: string) {
    this.$router.push({
      name: 'PdfView',
      params: { url }
    })
  }

  downloadFile (filePath: string) {
    // TODO，判断是否是小程序环境
    const a = document.createElement('a')
    a.href = filePath
    a.target = '_blank'
    a.click()
  }
}
